import { render, staticRenderFns } from "./mayiplatadd.vue?vue&type=template&id=33f1c4c5&"
import script from "./mayiplatadd.vue?vue&type=script&lang=js&"
export * from "./mayiplatadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f1c4c5')) {
      api.createRecord('33f1c4c5', component.options)
    } else {
      api.reload('33f1c4c5', component.options)
    }
    module.hot.accept("./mayiplatadd.vue?vue&type=template&id=33f1c4c5&", function () {
      api.rerender('33f1c4c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/mayiplatadd.vue"
export default component.exports